<template>
  <v-sheet>
    <v-pagination v-model="materialPage" :length="materialPageLength" />
    <v-row v-if="course.courseMaterials && course.courseMaterials.length > 0">
      <v-col cols="12" lg="4" md="6" v-for="cm in pagedMaterials" :key="cm.id">
        <v-card>
          <v-card-text>
            <span v-if="!cm.materials.s3Url">{{ cm.materials.name }}</span>
            <preview-pdf
              v-if="cm.materials.s3Url"
              :materialId="cm.materials.id"
              :s3Path="cm.materials.s3Url"
              :fileName="cm.materials.name"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
const PreviewPdf = () => import("@/components/resourceMgt/PreviewPdf.vue");

export default {
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  components: {
    PreviewPdf,
  },
  data: () => {
    return {
      materialPage: 1,
      materialPageSize: 24,
    };
  },
  computed: {
    materialPageLength() {
      if (
        this.course.courseMaterials &&
        this.course.courseMaterials.length > 0
      ) {
        return Math.ceil(
          this.course.courseMaterials.length / this.materialPageSize
        );
      } else {
        return 0;
      }
    },
    pagedMaterials() {
      if (
        this.course.courseMaterials &&
        this.course.courseMaterials.length > 0
      ) {
        const total = this.course.courseMaterials.length;
        const start = (this.materialPage - 1) * this.materialPageSize;
        const end =
          start + this.materialPageSize > total
            ? total
            : start + this.materialPageSize;
        const subset = this.course.courseMaterials.slice(start, end);
        return subset;
      } else {
        return [];
      }
    },
  },
  
};
</script>

<style>
</style>